import type { LegalTemplateId } from "@/features/legal";

export type TemplateCategory = "rental" | "services" | "goods" | "other";

export const TEMPLATE_CATEGORIES: TemplateCategory[] = ["rental", "services", "goods"];

const TEMPLATE_CATEGORY_MAP: Record<LegalTemplateId, TemplateCategory> = {
  vehicleRent: "rental",
  commercialPremiseRent: "rental",
  serviceContract: "services",
  paidService: "services",
  supplyContract: "goods",
  // platformAccess: "other",
};

export function getTemplateCategory(id: LegalTemplateId): TemplateCategory {
  return TEMPLATE_CATEGORY_MAP[id];
}
